var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgV2RestaurantStandard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.4911 4.00531C48.4911 4.00531 9.5902 3.99337 9.60136 4.00531C6.01569 4.00531 4 5.85596 4 9.63607V48.612C4 52.1486 5.81237 54 9.39485 54H48.6028C52.1852 54 54 52.2409 54 48.612V9.63607C54.0008 5.9475 52.186 4.00531 48.4911 4.00531ZM28.0296 22.0382C28.0296 23.2609 26.9141 24.5702 25.4662 24.5702V45.214C25.4662 48.1448 21.4651 48.1448 21.4651 45.214V24.5702C20.0562 24.5702 18.829 23.4869 18.829 21.8639V10.5029C18.829 9.51428 20.2603 9.47608 20.2603 10.5419V18.9395H21.4587V10.4639C21.4587 9.55567 22.8373 9.49757 22.8373 10.5029V18.9395H24.0756V10.4758C24.0756 9.52622 25.4135 9.48802 25.4135 10.5132V18.9395H26.6319V10.4758C26.6319 9.53657 28.0296 9.49916 28.0296 10.5132V22.0382ZM38.7029 45.2044C38.7029 48.0707 34.6938 48.0278 34.6938 45.2044V32.4831H32.5594V13.1432C32.5594 8.64109 38.7037 8.64109 38.7037 13.1432V45.2044H38.7029Z",
    fill: "#6b7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgV2RestaurantStandard);
export default __webpack_public_path__ + "static/media/v2-restaurant-standard.7baca3b9a1125d3826464fa2e880a47d.svg";
export { ForwardRef as ReactComponent };